export default __webpack_public_path__ + "static/media/jay_autos.b4a52a8d.png";